import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// This is an old route that is not used anymore. It is kept here for backward compatibility.
export const globalSettingsPerformanceMetricDetailRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-metric-detail',
	path: '/jira/settings/system/performance/metric/:metricKey',
};
